import { render, staticRenderFns } from "./Curtain.vue?vue&type=template&id=7a8529a0&scoped=true&"
import script from "./Curtain.vue?vue&type=script&lang=ts&"
export * from "./Curtain.vue?vue&type=script&lang=ts&"
import style0 from "./Curtain.vue?vue&type=style&index=0&id=7a8529a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8529a0",
  null
  
)

export default component.exports